export const PLAN_FREE = 'free';
export const PLAN_PREMIUM = 'premium';
export const LIMITE_PUBLICACIONES_ACTIVAS_FREE = 3;
export const LIMITE_PUBLICACIONES_ACTIVAS_PREMIUM = 15;

/** Días que suma admin al asignar User/Market Premium (mensual). */
export const PREMIUM_VIGENCIA_DIAS_DEFAULT = 30;

/**
 * `premium_hasta` ausente → cuentas legacy sin caducidad automática.
 * Si existe Timestamp y ya pasó → premium deja de aplicar en la app (hasta que Functions baje flags).
 */
export function premiumHastaSigueVigente(perfil, ahoraMs = Date.now()) {
  const h = perfil?.premium_hasta;
  if (h == null || h === undefined) return true;
  const ms = typeof h.toMillis === 'function' ? h.toMillis() : 0;
  return ms > ahoraMs;
}

export function normalizarPlan(plan) {
  const p = String(plan || '').trim().toLowerCase();
  if (p === PLAN_PREMIUM) return PLAN_PREMIUM;
  return PLAN_FREE;
}

/**
 * Marca premium por plan explícito o flag legacy.
 */
export function esNegocioPremiumPerfil(perfil) {
  return Boolean(perfil?.negocioPremium === true);
}

export function esUsuarioPremiumPerfil(perfil) {
  return normalizarPlan(perfil?.plan) === PLAN_PREMIUM;
}

/** User Premium o Negocio Premium (Market), respetando `premium_hasta` si existe. */
export function esCuentaPremiumPerfil(perfil) {
  if (!esUsuarioPremiumPerfil(perfil) && !esNegocioPremiumPerfil(perfil)) return false;
  return premiumHastaSigueVigente(perfil);
}
